import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export const ProblemSection = () => {
  return <section className="py-8 space-y-12" data-id="element-370">
      <FadeIn data-id="element-371">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6" data-id="element-372">
          ¿Por qué sigues sufriendo a pesar de todo lo que has intentado?
        </h2>
        <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-373">
          <p data-id="element-374">
            No es porque seas descuidado. No es porque comas "mal". Es porque
            nadie te ha explicado la verdad sobre el reflujo nocturno:
          </p>
          <div className="bg-slate-900 p-6 rounded-xl border border-slate-800 text-center" data-id="element-375">
            <p className="text-xl font-bold text-amber-500" data-id="element-376">
              El reflujo nocturno no es un problema de ácido.
              <br data-id="element-377" />
              <span className="text-white" data-id="element-378">Es un problema de mecánica.</span>
            </p>
          </div>
          <p data-id="element-379">
            Tu estómago tiene una válvula llamada Esfínter Esofágico Inferior
            (EEI). Cuando funciona bien, el ácido se queda abajo. Cuando falla,
            el ácido sube.
          </p>
          <p data-id="element-380">
            Y la razón por la que falla cada noche es una combinación de{' '}
            <strong className="text-white" data-id="element-381">presión, posición y tiempo</strong>.
            No de pH.
          </p>
          <p className="text-amber-400 font-medium" data-id="element-382">
            Mientras sigas atacando el síntoma con antiácidos en lugar de
            resolver la mecánica, seguirás atrapado en el mismo ciclo doloroso.
            Para siempre.
          </p>
        </div>
      </FadeIn>

      <FadeIn data-id="element-383">
        <h3 className="text-2xl font-bold text-white mb-6" data-id="element-384">
          ¿Por qué todo lo que has probado ha fallado?
        </h3>
        <ul className="space-y-4" data-id="element-385">
          {[{
          title: 'Los inhibidores de acidez (omeprazol)',
          desc: 'Reducen el pH, pero no fortalecen la válvula. El ácido sigue subiendo, solo quema un poco menos. Y a largo plazo, debilitan tu digestión.'
        }, {
          title: 'Beber leche o agua fría',
          desc: 'Alivio de 15 minutos seguido de un rebote de ácido más intenso. La leche estimula más producción de ácido 30 minutos después.'
        }, {
          title: 'Apilar almohadas',
          desc: 'Solo dobla tu cuello. La presión abdominal aumenta y el ácido sube con más facilidad.'
        }, {
          title: 'Dietas restrictivas de por vida',
          desc: 'Insostenibles. Y fallan porque el problema no es solo QUÉ comes, sino CUÁNDO y en qué POSICIÓN duermes después.'
        }, {
          title: "Los chicles de menta para 'refrescar'",
          desc: 'La menta relaja activamente la válvula del esófago. Estás literalmente abriendo la puerta al ácido.'
        }].map((item, i) => <li key={i} className="bg-slate-900/50 p-5 rounded-xl border border-slate-800 flex gap-4" data-id="element-386">
              <span className="text-red-500 flex-shrink-0 mt-1" data-id="element-387">❌</span>
              <div data-id="element-388">
                <strong className="text-white block mb-1" data-id="element-389">{item.title}:</strong>
                <span className="text-slate-400" data-id="element-390">{item.desc}</span>
              </div>
            </li>)}
        </ul>
      </FadeIn>
    </section>;
};